import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { Search } from "@mui/icons-material";

const UserControls = ({
  searchTerm,
  onSearchChange,
  rowsPerPage,
  onRowsPerPageChange,
  totalUsers,
}) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        gap: 2,
        alignItems: "flex-start",
        flexWrap: "wrap",
      }}
    >
      <TextField
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        size="small"
        sx={{ minWidth: 250 }}
        InputProps={{
          startAdornment: <Search sx={{ color: "text.secondary", mr: 1 }} />,
        }}
      />

      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Rows per page</InputLabel>
        <Select
          value={rowsPerPage}
          label="Rows per page"
          onChange={(e) => onRowsPerPageChange(e.target.value)}
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
        </Select>
      </FormControl>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ alignSelf: "center" }}
      >
        {totalUsers} users found
      </Typography>
    </Box>
  );
};

export default UserControls;
